import React, { useState, useEffect } from 'react';
import { connect, useSelector } from 'react-redux';

import { Box, Button, makeStyles } from '@material-ui/core';
import SaveIcon from '@material-ui/icons/Save';
import CloseIcon from '@material-ui/icons/Close';

import Dialog from 'components/RMSDialog';
import AttachmentIcon from 'components/AttachmentIcon';
import RMSCheckbox2 from 'components/RMSCheckbox/RMSCheckbox2';
import RMSTextField from 'components/RMSTextField';
import RMSDictionary from 'components/RMSAutoComplete/RMSDictonary';
import RecordHistory from 'components/RecordHistory';
import RMSAutoComplete from 'components/RMSAutoComplete/RMSAutoComplete';

import { useError } from 'utils/formStyles';

import { showSpinner, hideSpinner } from 'reducers/UiReducer';
import { handleError } from 'reducers/ErrorReducer';
import { notifyDataUpdate } from 'reducers/DataUpdateReducer';
import { closeEditAttachment } from 'reducers/PersonDialogsReducer';
import { updateAttachment } from 'reducers/helpers/fileHelpers';

const useStyles = makeStyles((theme) => ({
  fileInfo: {
    minHeight: 35,
    marginBottom: 16,
    '& img': {
      maxHeight: 24,
      borderRadius: 3,
      marginRight: 8,
    },
  },
  txtField: {
    minWidth: 350,
  },
}));

function EditAttachment(props) {
  const classes = useStyles();
  const { FileType } = props.data;

  const [FileName, setFileName] = useState('');
  const [Description, setDescription] = useState('');
  const [IsDeleted, setIsDeleted] = useState(false);
  const [codeAttachmentType, setCodeAttachmentType] = useState();
  const [clearanceLevel, setClearanceLevel] = useState('');
  const [errors, setErrors] = useState();
  const [attachmentFormState, setAttachmentFormState] = useState({
    isValid: false,
    changes: false,
    values: {},
    touched: {},
    errors: {},
    formType: 'edit',
  });
  const [recordHistoryData, setRecordHistoryData] = useState({
    shouldVisible: true,
    isDisabled: true,
    createUpdateInfo: {},
  });
  const [showRecordHistory, setShowRecordHistory] = useState(false);

  const secClearanceLevel = useSelector((state) => state.user.userClearanceOptions);

  const {
    err,
    // isValidAndChanged,
    formChanged,
  } = useError(errors, setErrors);

  useEffect(() => {
    const {
      Description,
      IsDeleted,
      FileName,
      codeAttachmentType,
      Created,
      CreatedBy,
      Updated,
      UpdatedBy,
      ParentType,
    } = props.data;

    setRecordHistoryData({
      shouldVisible: true,
      isDisabled: !Created,
      createUpdateInfo: {
        created: Created,
        createdBy: CreatedBy,
        updated: Updated,
        updatedBy: UpdatedBy,
      },
    });

    if (ParentType === 'INCIDENT') setClearanceLevel(props.data?.ClearanceLevel);
    setDescription(Description);
    setIsDeleted(Boolean(IsDeleted));
    setFileName(FileName.substr(0, FileName.length - FileType.length - 1));
    setCodeAttachmentType(codeAttachmentType);
  }, []);

  const close = () => {
    props.closeEditAttachment();
  };

  const save = () => {
    const type = props.data.ParentType;
    const data = {
      ptsAttachmentID: props.data.ptsAttachmentID,
      FileName: `${FileName}.${FileType}`,
      Description,
      IsDeleted: IsDeleted ? 1 : 0,
      codeAttachmentType: codeAttachmentType,
    };
    if (type === 'INCIDENT') data.ClearanceLevel = clearanceLevel;

    props.showSpinner();
    updateAttachment(data)
      .then(() => {
        props.notifyDataUpdate({ type: 'file-upload', data: type });
        props.closeEditAttachment();
      })
      .catch(props.handleError)
      .finally(props.hideSpinner);
  };

  const handleCloseRecordHistoryDialog = () => setShowRecordHistory(false);

  const renderActions = () => {
    return (
      <>
        {recordHistoryData?.shouldVisible && (
          <Box className={classes.btn}>
            <RecordHistory
              showRecordHistory={showRecordHistory}
              setShowRecordHistory={setShowRecordHistory}
              disabled={recordHistoryData?.isDisabled}
              handleCloseRecordHistoryDialog={handleCloseRecordHistoryDialog}
              createUpdateInfo={recordHistoryData?.createUpdateInfo}></RecordHistory>
          </Box>
        )}
        <Button
          color="primary"
          variant="contained"
          autoFocus
          onClick={save}
          // disabled={!isValidAndChanged()}
        >
          <SaveIcon /> Save
        </Button>
        <Button color="primary" onClick={close}>
          <CloseIcon /> Close
        </Button>
      </>
    );
  };

  const renderFileName = () => {
    const onChange = (ev, val) => {
      setFileName(val);
      formChanged();
    };
    const error = err(FileName, 'FileName', 'File name cannot be empty');
    return (
      <div>
        <RMSTextField
          label="File Name"
          value={FileName}
          onChange={onChange}
          className={classes.txtField}
          error={error}
          max={255}
        />
      </div>
    );
  };

  const renderDescription = () => {
    const onChange = (ev, val) => {
      setDescription(val);
      formChanged();
    };
    return (
      <div>
        <RMSTextField
          label="Description"
          value={Description}
          onChange={onChange}
          className={classes.txtField}
          compact
          max={50}
        />
      </div>
    );
  };

  const renderIsDeleted = () => {
    const onChange = (ev, val) => {
      setIsDeleted(val);
      formChanged();
    };
    return (
      <div>
        <RMSCheckbox2 checked={IsDeleted} onChange={onChange} label="Is Deleted" />
      </div>
    );
  };

  const renderAttachmentType = () => {
    return (
      <RMSDictionary
        compact
        options="codeAttachmentTypes"
        value={{ Code: codeAttachmentType }}
        className={classes.item2}
        onChange={(e, value) => {
          setCodeAttachmentType(value ? value.Code : '');
          formChanged();
        }}
        label="Type"
      />
    );
  };

  const renderClearanceLevel = () => {
    return (
      <RMSAutoComplete
        size="small"
        id="combo-attachment-clearance-level"
        autoComplete
        autoSelect
        autoHighlight
        options={secClearanceLevel}
        label="Clearance Level"
        serviceName="secClearanceLevel"
        variant="outlined"
        title={'Level'}
        formType={'edit'} // ClearanceLevel dictionary table do not have default option column
        stateHolder={attachmentFormState}
        setStateHolder={setAttachmentFormState}
        stateHolderAttribute="clearanceLevel" //need to review
        setField={(e, value) => setClearanceLevel(value)}
        value={clearanceLevel} //need to review
        className="mb-2"
      />
    );
  };

  return (
    <Dialog toolbar onClose={close} title="Edit Attachment" actions={renderActions()}>
      <div className={classes.fileInfo}>
        <AttachmentIcon type={FileType} />
        {props.data.FileName}
      </div>
      {renderFileName()}
      {renderAttachmentType()}
      {props.data?.ParentType === 'INCIDENT' && renderClearanceLevel()}
      {renderDescription()}
      {renderIsDeleted()}
    </Dialog>
  );
}

export default connect(null, {
  closeEditAttachment,
  showSpinner,
  hideSpinner,
  handleError,
  notifyDataUpdate,
})(EditAttachment);
